import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  RowVisibility,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";
import { useLocationsOptions } from "./useLocationsOptions";
import { useActivityLocations } from "./useActivityLocations";

export const LOCATIONS_ID = "locations";

export function useLocationsFilter(
  filterValues: FilterValue[]
): MultiSelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: LOCATIONS_ID,
    value: [],
  };

  const taskTypeValue = filterValues.find(
    ({ filterId }) => filterId === TASK_TYPE_ID
  );
  const taskTypeValueValue = (taskTypeValue as StringFilterValue)?.value ?? "";

  const isSingleLocationsAvailable =
    taskTypeValueValue === "productIssue" ||
    taskTypeValueValue === "PQR" ||
    taskTypeValueValue === "testbuy" ||
    taskTypeValueValue === "mfaq" ||
    taskTypeValueValue === "custom" ||
    taskTypeValueValue === "main" ||
    taskTypeValueValue === "planned";

  const enabled = isSingleLocationsAvailable;
  const { data: taskLocations, isFetching } = useActivityLocations(
    taskTypeValueValue,
    "",
    enabled
  );

  const options = useLocationsOptions(taskTypeValueValue, taskLocations ?? []);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: LOCATIONS_ID,
    title: t("location3String"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    rowVisibility: RowVisibility.PillOnly,
    noResultsTitle: t("noLocationsString"),
    noResultsDescription: t("noLocationsAvailableTaskTypeString"),
    isFetching,
  };
}
